import { Component, Input } from '@angular/core';
import { IOrderEntryOverviewModel } from '../order-entry-data.service';

@Component({
  selector: 'order-bp-overview',
  template: `
    <p>
      <location-info [location]="model.bp"></location-info>
    </p>
    <p>
      <span *ngIf="model.bp?.telephoneNumber"><span translate>GA.GENERAL.PHONE</span>: {{model.bp?.telephoneNumber}}<br/></span>
      <span *ngIf="model.bp?.faxNumber"><span translate>GA.GENERAL.FAX</span>: {{model.bp?.faxNumber}}<br/></span>
      <span *ngIf="model.bp?.homePage"><span translate>GA.GENERAL.HOMEPAGE</span>: <a [href]="model.bp?.homePage" target="_blank">{{model.bp?.homePage}}</a></span>
    </p>
  `
})
export class OrderBPOverviewComponent {
  @Input() public model:IOrderEntryOverviewModel['shippedFrom'];
}